/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntAppControllerGetLowerthirdByDateQueryResponse, PntAppControllerGetLowerthirdByDatePathParams, PntAppControllerGetLowerthirdByDateQueryParams } from "../models/PntAppControllerGetLowerthirdByDate";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { pntAppControllerGetLowerthirdByDate } from "../axios/pntAppControllerGetLowerthirdByDate";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const pntAppControllerGetLowerthirdByDateQueryKey = (slug: PntAppControllerGetLowerthirdByDatePathParams["slug"], params: PntAppControllerGetLowerthirdByDateQueryParams) => ["api-v2", { url: '/pnt/v2/segments/:slug/lowerthird', params: {slug:slug} }, ...(params ? [params] : [])] as const

export type PntAppControllerGetLowerthirdByDateQueryKey = ReturnType<typeof pntAppControllerGetLowerthirdByDateQueryKey>

export function pntAppControllerGetLowerthirdByDateQueryOptions(slug: PntAppControllerGetLowerthirdByDatePathParams["slug"], params: PntAppControllerGetLowerthirdByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = pntAppControllerGetLowerthirdByDateQueryKey(slug, params)
        return queryOptions<PntAppControllerGetLowerthirdByDateQueryResponse, ResponseErrorConfig<Error>, PntAppControllerGetLowerthirdByDateQueryResponse, typeof queryKey>({
         enabled: !!(slug&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return pntAppControllerGetLowerthirdByDate(slug, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve the lowerthirds for a given time range
 * {@link /pnt/v2/segments/:slug/lowerthird}
 */
export function usePntAppControllerGetLowerthirdByDate<TData = PntAppControllerGetLowerthirdByDateQueryResponse, TQueryData = PntAppControllerGetLowerthirdByDateQueryResponse, TQueryKey extends QueryKey = PntAppControllerGetLowerthirdByDateQueryKey>(slug: PntAppControllerGetLowerthirdByDatePathParams["slug"], params: PntAppControllerGetLowerthirdByDateQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PntAppControllerGetLowerthirdByDateQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? pntAppControllerGetLowerthirdByDateQueryKey(slug, params)
         

         const query = useQuery({
          ...pntAppControllerGetLowerthirdByDateQueryOptions(slug, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}